import { Tag } from '../Tag';

type LeistungIndexTagProps = {
  index: number;
};

export const LeistungIndexTag = function ({ index }: LeistungIndexTagProps) {
  return (
    <Tag style="brandLight" size="small">
      {`Leistung ${index}`}
    </Tag>
  );
};
